import productListController from './productsListController'

export default productListController



// WEBPACK FOOTER //
// ../src/controllers/productListController/index.js